/* global femcare */

femcare.shared.inputs = {

    init: function () {
        if ($('form').length) {
            this.initAutoHeightTextarea();
            this.initTextareaCharacterCount();
            this.initSingleFieldDates();
            this.initMultipleChoiceInputs();
            this.initSubmitConsent();
            this.initCheckboxGroupSingleSelect();
            this.initSelectMenus();
            this.initCustomRadioOptions();
            this.initCustomSelectOptions();
            this.initLargeCounter();
        }
    },

    // For dynamicaly loaded forms, such as Smaple form 
    initInputsForForm: function ($form) {
        this.initAutoHeightTextarea($form);
        this.initTextareaCharacterCount($form);
        this.initSingleFieldDates($form);
        this.initMultipleChoiceInputs();
        this.initSubmitConsent($form);
        this.initCheckboxGroupSingleSelect($form);
        this.initSelectMenus($form);
        this.initCustomRadioOptions($form);
        this.initCustomSelectOptions($form);
        this.initLargeCounter($form);
    },

    initSingleFieldDates: function ($container) {
        var $datepickerElements = ($container || $('body')).find('.form-group--single-field-date');

        if ($datepickerElements.length) {

            var datepickerLoaded = !!$.fn.datepicker;

            if (datepickerLoaded) {
                instantiateSingleFieldDates();
            } else {
                var assetsPath = femcare.shared.util.getAssetsPath();
                $.getScript(assetsPath + '/js/datepicker.js', function () {
                    var localization = $('body').attr('data-google-language-code');
                    $.datepicker.setDefaults($.datepicker.regional[(localization || 'en')]);

                    instantiateSingleFieldDates();
                });
            }

            function instantiateSingleFieldDates() {
                const today = new Date();
                $datepickerElements.each(function () {
                    let inputDate = $(this).find('input[type="date"]');
                    $(this).singleFieldDate();

                    const offset = Number(inputDate.data("offset")) || 0;
                    let startDate;

                    if (offset === 0) {
                        startDate = today;
                    } else {
                        startDate = new Date(
                            today.getFullYear() - offset,
                            today.getMonth(),
                            today.getDate()
                        );
                    }

                    const yyyy = startDate.getFullYear();
                    const mm = String(startDate.getMonth() + 1).padStart(2, '0');
                    const dd = String(startDate.getDate()).padStart(2, '0');
                    const formattedDate = `${yyyy}-${mm}-${dd}`;

                    inputDate.val(formattedDate);
                });
            }

        }
    },

    /**
     * Init multiChoice widgets.
     * @param {object} $container jQuery object within which multi choice widgets are to be initialized.
     */
    initMultipleChoiceInputs: function ($container) {
        ($container || $('body')).find('.form-group--multiple-choice-checkbox').each(function () {
            $(this).multiChoice();
        });
    },

    /**
     * Init selectmenu widgets.
     * @param {object} $container jQuery object within which selectmenu are to be initialized.
     */
    initSelectMenus: function ($container) {
        ($container || $('body')).find('.form-group--product-radio-group').each(function () {
            var $select = $(this).find('select');
            var selectedOption = $select.find('option[selected]').val();
            $select.val(selectedOption);

            $(this).find('select').selectmenu({
                icons: { button: 'icon-arrow-down-smooth' }
            });
        });
    },

    /**
     * Initializes mandatory consent checkboxes in forms. Blocks submit button until checkboxes are checked.
     * @param {jQuery} $container - The container for initializing consent checkboxes.
     */
    initSubmitConsent: function ($container) {
        $container = $container || $('body form');
        var $allForms = $container.find('form').addBack('form');
        var consentCheckboxSelector = '.consentCheckbox';

        $.each($allForms, function (index, form) {
            var $form = $(form);
            var $consentFields = $form.find(consentCheckboxSelector);
            var hasConsentFields = $consentFields.length;

            if (hasConsentFields) {
                // TODO: Currently submit button will be enabled always on forms - remove functionality if not used for long time
                // this.initConsentCheckboxes($form, $consentFields);
            } else {
                // No consent needed so free to submit

                var $submit = $form.find('button[type="submit"]');
                if ($submit.length) {
                    $submit.prop('disabled', false);
                }
            }
        });
    },

    /**
     * Initializes consent checkboxes in a form, updating the submit button's disabled state based on checkbox status.
     * @param {jQuery} $form - The form containing the consent checkboxes.
     * @param {jQuery} $checkboxes - The consent checkboxes to be initialized.
     */
    initConsentCheckboxes: function ($form, $checkboxes) {
        let $submitButton = $form.find('button[type="submit"]');
        $submitButton.prop('disabled', true); // Initially disable submit button

        // Checks if any '.form-group' has 'has-error'
        const updateButtonState = () => {
            femcare.shared.util.updateFormButtonState($form);
        }

        // Check state initially and on changes
        updateButtonState();
        $checkboxes.on('change', updateButtonState);
        $form.on('inputsInvalid recaptchaInvalid', updateButtonState);
    },

    /**
     * Init auto height textarea.
     * @param {object} $container jQuery object within which textareas are to be initialized.
     */
    initAutoHeightTextarea: function ($container) {
        ($container || $('body'))
            .find('textarea')
            .each(function () {
                $(this).attr(
                    'style',
                    'height:' + this.scrollHeight + 'px;overflow-y:hidden;'
                );
                if (!$(this).attr('maxlength')) {
                    $(this).attr('maxlength', 2000);
                }
            })
            .on('input', function () {
                this.style.height = 'auto';
                this.style.height = this.scrollHeight + 'px';
            });
    },

    /**
     * Init textarea char count indicator.
     * @param {object} $container jQuery object within which textareas are to be initialized.
     */
    initTextareaCharacterCount: function ($container) {
        const $textAreaWrappers = ($container || $('body')).find(
            '.textarea-char-count-wrapper'
        );

        $textAreaWrappers.find('textarea').on('change input', function () {
            const length = $(this).val().length;
            const maxLength = parseInt($(this).attr('maxlength'), 10);
            const counterTextFormat = $(this).attr('data-counter-format') || 'characters typed';

            if (length <= maxLength) {
                const $count = $(this)
                    .parent('.textarea-char-count-wrapper')
                    .find('.counter');
                const remaining = maxLength - length;
                $count.text(`${remaining} ${counterTextFormat} ${maxLength}`);
            }
        });
    },

    /**
     * Make checkbox behavior be like radio buttons ( single select and cannot unselect ).
     * @param {object} $container jQuery object within which checkbox group is to be initialized.
     */

    initCheckboxGroupSingleSelect: function ($container) {
        var $checkboxGroups = ($container || $('body')).find(
            '.form-group--single-select-checkbox'
        );

        $checkboxGroups.find('input[type="checkbox"]').on('click', function () {
            var $checkboxGroup = $(this).closest('.form-group--single-select-checkbox');

            $checkboxGroup.find('input[name="' + $(this).attr('name') + '"]').prop('checked', false);
            $(this).prop('checked', true);
        });
    },

    /**
     * Initializes custom options for radio buttons, showing a custom input field
     * when a specific radio button is selected and hiding it when others are selected.
     * @param {jQuery} [$container] - A jQuery object to limit the scope of initialization. Defaults to the document body if not provided.
     */
    initCustomRadioOptions: function ($container) {
        const $customOptions = ($container || $('body')).find('.form-radio-control .form-group-custom-option');

        $customOptions.each((index, element) => {
            const $customOption = $(element);
            const $customOptionInput = $customOption.find('input');
            const $parentRadioButtonGroup = $customOption.closest('.form-group');
            const $associatedRadioButton = $customOption.closest('.form-radio-control').find('input[type="radio"]');
            const $unassociatedRadioButtons = $parentRadioButtonGroup.find('input[type="radio"]').not($associatedRadioButton);
            const $hiddenInput = $parentRadioButtonGroup.find('input[type="hidden"][data-validate]');
            const isMandatory = $hiddenInput.prop('required') === true;

            // When the custom radio button is selected
            $associatedRadioButton.on('change', function () {
                $customOption.removeClass('hidden');
                $customOptionInput.val('');
                $customOptionInput.prop('required', isMandatory);
                $customOptionInput.trigger('focus');
                $customOptionInput.validate();
            });

            // When a different radio button is selected
            $unassociatedRadioButtons.on('change', function () {
                $customOption.addClass('hidden');
                $customOptionInput.val('');
                $customOptionInput.prop('required', false);
                $associatedRadioButton.val($associatedRadioButton.attr('value'));
            });

            // When typing in the custom input, update the radio value and hidden field
            $customOptionInput.on('input', function () {
                if ($associatedRadioButton.is(':checked')) {
                    $associatedRadioButton.val($customOptionInput.val());
                    if ($hiddenInput.length) {
                        $hiddenInput.val($customOptionInput.val());
                        $hiddenInput.validate();
                    }
                }
            });

            // Ensure the custom text value is retained on form submit
            $customOptionInput.on('blur', function () {
                if ($associatedRadioButton.is(':checked')) {
                    $associatedRadioButton.val($customOptionInput.val());
                }
            });

            // Initialize state on load (handle browser autofill, back button, etc.)
            if ($associatedRadioButton.is(':checked')) {
                $customOption.removeClass('hidden');
                $customOptionInput.prop('required', isMandatory);
            } else {
                $customOption.addClass('hidden');
                $customOptionInput.prop('required', false);
            }

            // Set hidden field when any radio is selected
            $parentRadioButtonGroup.find('input[type="radio"]').on('change', function () {
                const selectedVal = $parentRadioButtonGroup.find('input[type="radio"]:checked').val();
                if ($hiddenInput.length) {
                    $hiddenInput.val(selectedVal);
                }
            });
        });
    },

    initCustomSelectOptions: function ($container) {
        var $customOptions = ($container || $('body')).find('.form-group select+.form-group-custom-option');

        $customOptions.each(function (index, element) {
            var $customOption = $(element);
            var $customOptionInput = $customOption.find('input');
            var $select = $customOption.prev('select');
            var $associatedOption = $select.find('option:last-child');

            $select.on('change', function () {
                if ($select.val() === $associatedOption.val()) {
                    $customOption.show();
                    $customOptionInput.resetInput();
                    $customOptionInput.focus();
                } else {
                    $customOption.hide();
                    $customOptionInput.resetInput();
                }
            })

        });
    },

    initLargeCounter: function () {
        var $largeCounter = $('.counter--large')

        $largeCounter.each(function (index, element) {
            $(element).counter({ max: parseInt($(element).attr('data-max'), 10) });
        })
    },

    /**
     * Merges the values from multiple input fields within a given form and updates
     * a designated complete field with the concatenated result.
     * @param {jQuery} $form - The jQuery object representing the form containing the input fields.
     */
    mergeMultiInputField: function ($form) {
        var $multiInputContainer = $form.find('.multi-input-container');
        var $multiInputComplete = $multiInputContainer.find('.multi-input-complete-field');
        var concatVal = '';

        $multiInputContainer.each(function (index, element) {
            $(element).find('.multi-input-field').each(function (i, e) {
                var inputVal = e.value;
                concatVal = concatVal + inputVal;
            });

            $multiInputComplete.val(concatVal);
        })
    }
};
